<div class="card">
	<div *ngIf="menuItem.priceLevel" class="p-grid">
		<div class="p-col"></div>
	</div>
	<div class="p-grid">
		<div class="p-col-12 p-md-4">
			<div class="d-flex">
				<div class="h4 ms-1 mt-2 mb-1">Serving Size</div>
			</div>
			<p-divider></p-divider>
			<div class="d-flex w-100">
				<span class="p-float-label mt-4 w-100">
					<input
						pInputText
						#idValue
						name="idValue"
						type="text"
						[(ngModel)]="menuItem.nutritionalInformation[selectedPriceLevelIndex].servingSize"
						(change)="changesToSave.emit(true)"
						class="w-100"
					/>
					<label for="idValue">Serving Size</label>
				</span>
			</div>
		</div>
		<div class="p-col-12 p-md-4">
			<div class="d-flex">
				<div class="h4 ms-1 mt-2 mb-1">Nutrition</div>
			</div>
			<p-divider></p-divider>
			<div class="d-flex">
				<span class="p-float-label mt-4 w-50">
					<p-inputNumber
						#totalFatValue
						[(ngModel)]="menuItem.nutritionalInformation[selectedPriceLevelIndex].totalFat.value"
						inputStyleClass="text-right"
						styleClass="w-100"
						(ngModelChange)="changesToSave.emit(true)"
					></p-inputNumber>
					<label for="totalFatValue">Total Fat</label>
				</span>
				<span class="p-float-label mt-4 ms-auto w-50">
					<p-dropdown
						#totalFatValueUom
						[options]="nutritionalUom"
						optionLabel="label"
						optionValue="value"
						name="totalFatValueUom"
						[(ngModel)]="menuItem.nutritionalInformation[selectedPriceLevelIndex].totalFat.uom"
						(ngModelChange)="changesToSave.emit(true)"
						[style]="{ width: '100%' }"
						appendTo="body"
						[autoDisplayFirst]="false"
						[virtualScroll]="true"
						virtualScrollItemSize="30"
						filter="true"
						(filterBy)="app.keys(nutritionalUom)"
					></p-dropdown>
					<label for="idValue">unit of measurement</label>
				</span>
			</div>
			<div class="d-flex">
				<span class="p-float-label mt-4 w-50">
					<p-inputNumber
						#cholesterolValue
						[(ngModel)]="menuItem.nutritionalInformation[selectedPriceLevelIndex].cholesterol.value"
						(ngModelChange)="changesToSave.emit(true)"
						inputStyleClass="text-right"
						styleClass="w-100"
					></p-inputNumber>
					<label for="totalFatValue">Cholesterol</label>
				</span>
				<span class="p-float-label mt-4 ms-auto w-50">
					<p-dropdown
						#cholesterolValueUom
						[options]="nutritionalUom"
						optionLabel="label"
						optionValue="value"
						name="totalFatValueUom"
						[(ngModel)]="menuItem.nutritionalInformation[selectedPriceLevelIndex].cholesterol.uom"
						(ngModelChange)="changesToSave.emit(true)"
						[style]="{ width: '100%' }"
						appendTo="body"
						[autoDisplayFirst]="false"
						[virtualScroll]="true"
						virtualScrollItemSize="30"
						filter="true"
						(filterBy)="app.keys(nutritionalUom)"
					></p-dropdown>
					<label for="idValue">unit of measurement</label>
				</span>
			</div>
			<div class="d-flex">
				<span class="p-float-label mt-4 w-50">
					<p-inputNumber
						#sodiumValue
						[(ngModel)]="menuItem.nutritionalInformation[selectedPriceLevelIndex].sodium.value"
						(ngModelChange)="changesToSave.emit(true)"
						inputStyleClass="text-right"
						styleClass="w-100"
					></p-inputNumber>
					<label for="totalFatValue">Sodium</label>
				</span>
				<span class="p-float-label mt-4 ms-auto w-50">
					<p-dropdown
						#sodiumValueUom
						[options]="nutritionalUom"
						optionLabel="label"
						optionValue="value"
						name="totalFatValueUom"
						[(ngModel)]="menuItem.nutritionalInformation[selectedPriceLevelIndex].sodium.uom"
						(ngModelChange)="changesToSave.emit(true)"
						[style]="{ width: '100%' }"
						appendTo="body"
						[autoDisplayFirst]="false"
						[virtualScroll]="true"
						virtualScrollItemSize="30"
						filter="true"
						(filterBy)="app.keys(nutritionalUom)"
					></p-dropdown>
					<label for="idValue">unit of measurement</label>
				</span>
			</div>
			<div class="d-flex">
				<span class="p-float-label mt-4 w-50">
					<p-inputNumber
						#carbohydratesValue
						[(ngModel)]="menuItem.nutritionalInformation[selectedPriceLevelIndex].carbohydrates.value"
						(ngModelChange)="changesToSave.emit(true)"
						inputStyleClass="text-right"
						styleClass="w-100"
					></p-inputNumber>
					<label for="totalFatValue">Carbohydrates</label>
				</span>
				<span class="p-float-label mt-4 ms-auto w-50">
					<p-dropdown
						#carbohydratesValueUom
						[options]="nutritionalUom"
						optionLabel="label"
						optionValue="value"
						name="totalFatValueUom"
						[(ngModel)]="menuItem.nutritionalInformation[selectedPriceLevelIndex].carbohydrates.uom"
						(ngModelChange)="changesToSave.emit(true)"
						[style]="{ width: '100%' }"
						appendTo="body"
						[autoDisplayFirst]="false"
						[virtualScroll]="true"
						virtualScrollItemSize="30"
						filter="true"
						(filterBy)="app.keys(nutritionalUom)"
					></p-dropdown>
					<label for="idValue">unit of measurement</label>
				</span>
			</div>
			<div class="d-flex">
				<span class="p-float-label mt-4 w-50">
					<p-inputNumber
						#proteinValue
						[(ngModel)]="menuItem.nutritionalInformation[selectedPriceLevelIndex].protein.value"
						(ngModelChange)="changesToSave.emit(true)"
						inputStyleClass="text-right"
						styleClass="w-100"
					></p-inputNumber>
					<label for="totalFatValue">Protein</label>
				</span>
				<span class="p-float-label mt-4 ms-auto w-50">
					<p-dropdown
						#proteinValueUom
						[options]="nutritionalUom"
						optionLabel="label"
						optionValue="value"
						name="totalFatValueUom"
						[(ngModel)]="menuItem.nutritionalInformation[selectedPriceLevelIndex].protein.uom"
						(ngModelChange)="changesToSave.emit(true)"
						[style]="{ width: '100%' }"
						appendTo="body"
						[autoDisplayFirst]="false"
						[virtualScroll]="true"
						virtualScrollItemSize="30"
						filter="true"
						(filterBy)="app.keys(nutritionalUom)"
					></p-dropdown>
					<label for="idValue">unit of measurement</label>
				</span>
			</div>
			<div class="d-flex">
				<span class="p-float-label mt-4 w-50">
					<p-inputNumber
						#sugarValue
						[(ngModel)]="menuItem.nutritionalInformation[selectedPriceLevelIndex].sugar.value"
						(ngModelChange)="changesToSave.emit(true)"
						inputStyleClass="text-right"
						styleClass="w-100"
					></p-inputNumber>
					<label for="totalFatValue">Sugar</label>
				</span>
				<span class="p-float-label mt-4 ms-auto w-50">
					<p-dropdown
						#sugarValueUom
						[options]="nutritionalUom"
						optionLabel="label"
						optionValue="value"
						name="totalFatValueUom"
						[(ngModel)]="menuItem.nutritionalInformation[selectedPriceLevelIndex].sugar.uom"
						(ngModelChange)="changesToSave.emit(true)"
						[style]="{ width: '100%' }"
						appendTo="body"
						[autoDisplayFirst]="false"
						[virtualScroll]="true"
						virtualScrollItemSize="30"
						filter="true"
						(filterBy)="app.keys(nutritionalUom)"
					></p-dropdown>
					<label for="idValue">unit of measurement</label>
				</span>
			</div>
		</div>
		<div class="p-col-12 p-md-4">
			<div class="d-flex">
				<div class="h4 ms-1 mt-2 mb-1">Allergens</div>
			</div>
			<p-divider></p-divider>
			<div class="d-flex w-100">
				<span class="p-float-label mt-4 w-100">
					<p-chips
						[(ngModel)]="allergenList"
						(ngModelChange)="changesToSave.emit(true)"
						class="p-fluid w-100"
						id="customerService.customer.valueTags"
						(onAdd)="allergenAdd($event)"
						allowDuplicate="false"
						addOnTab="true"
						addOnBlur="true"
						name="allergenInput"
					></p-chips>
					<label for="customerService.customer.valueTags">Tags</label>
				</span>
			</div>
		</div>
	</div>
</div>
